"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return "nc-" + parseInt(Math.random() * 1000000000);
};